"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendStatus = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-expressions */
const react_1 = require("react");
const de_ui_1 = require("@delab-team/de-ui");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const react_i18next_1 = require("react-i18next");
const money_gif_1 = __importDefault(require("../../assets/gifs/money.gif"));
const error_gif_1 = __importDefault(require("../../assets/gifs/error.gif"));
const send_success_module_css_1 = __importDefault(require("./send-success.module.css"));
const SendStatus = (props) => {
    const TgObj = sdk_1.default;
    const { t } = (0, react_i18next_1.useTranslation)();
    (0, react_1.useEffect)(() => {
        if (props.sendSuccess) {
            window.document.body.style.overflowY = 'hidden';
        }
        return () => {
            window.document.body.style.overflowY = 'visible';
        };
    }, [props.sendSuccess]);
    const handleClick = () => {
        console.log('SEND STATUS');
        // window.open(`https://tonviewer.com/${props.sendTo}`, '_blank')
        TgObj.openLink(`https://tonviewer.com/${props.addressUser}`);
    };
    function enableBtn() {
        if (props.isSuccess) {
            TgObj.MainButton.show();
            TgObj.MainButton.enable();
            TgObj.MainButton.text = t('common.view-in-blockchain');
            TgObj.MainButton.color = '#007AFF';
        }
        else {
            TgObj.MainButton.hide();
        }
    }
    (0, react_1.useEffect)(() => {
        console.log('props.isSuccess', props.isSuccess);
        enableBtn();
        TgObj.MainButton.onClick(handleClick);
        return () => {
            TgObj.MainButton.offClick(handleClick);
        };
    }, [props.isSuccess, props.sendSuccess]);
    return ((0, jsx_runtime_1.jsx)("div", { className: send_success_module_css_1.default.wrapper, children: (0, jsx_runtime_1.jsx)("div", { className: send_success_module_css_1.default.modal, children: (0, jsx_runtime_1.jsx)("div", { className: `${send_success_module_css_1.default.modalContent}`, children: props.isSuccess ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { src: money_gif_1.default, alt: "success" }), (0, jsx_runtime_1.jsxs)(de_ui_1.Title, { variant: "h3", className: send_success_module_css_1.default.modalContentTitle, children: [t('send-status.your-tx'), " ", (0, jsx_runtime_1.jsx)("br", {}), " ", t('send-status.sent-successfully')] }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: send_success_module_css_1.default.modalContentText, children: t('send-status.being-processed') })] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { src: error_gif_1.default, alt: "success" }), (0, jsx_runtime_1.jsxs)(de_ui_1.Title, { variant: "h3", className: send_success_module_css_1.default.modalContentTitle, children: [t('send-status.your-tx'), " ", (0, jsx_runtime_1.jsx)("br", {}), " ", t('send-status.failed')] }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: send_success_module_css_1.default.modalContentText, children: t('send-status.check-balance') }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: `${send_success_module_css_1.default.modalContentTextErr}`, children: props.errorMessage })] })) }) }) }));
};
exports.SendStatus = SendStatus;
